import {registerReactComponent} from '@zui/core';
import * as components from './index';

registerReactComponent(components);
